module.exports = __webpack_public_path__ + "img/mira_160l_list.5e01d856.jpg";